import {createContext, useContext, useState} from 'react'

const PaymentContext = createContext()

export function usePayment() {
  return useContext(PaymentContext)
}

export const PaymentConsumer = PaymentContext.Consumer

export function PaymentProvider({ children }) {
  const [payment, setPayment] = useState({active: false})

  const setActive = (value) => {
    if (!value) {
      setPayment((current) => ({
        ...current,
        active: false,
      }))
      return
    }

    if (typeof value === 'object') {
      setPayment({
        ...value,
        active: true,
      })
      return
    }

    setPayment({
      active: true,
      code: value,
    })
  }

  const value = {
    active: payment.active,
    payment,
    setActive,
  }

  return <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>
}
